export const roles = {
  ADMIN: 'ADMIN',
  INFLUENCER: 'INFLUENCER',
  NORMAL: 'NORMAL',
};
